import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Header, { Modal, ModalHead } from '../Component/Header'
import Footer from '../Component/footer'
import { GetAction } from '../Component/GetAction'
import { mediaUrl } from '../utils/mediaUrl'
import { mockImg } from '../design/mockImg'

const SERVICES = {
  gauseva: {
    title: 'जीवदया एवं गौसेवा',
    text: 'ट्रस्ट गोशाला में गौ-वंश की देखभाल, चारे-पानी की व्यवस्था और बीमार पशुओं की सेवा करता है। आहार दान और स्वयंसेवा से यह नित्य कार्य चलता है।',
  },
  education: {
    title: 'छात्रावास एवं शिक्षा',
    text: 'विद्यार्थियों को सुरक्षित आवास, अध्ययन का शांत समय, संस्कार और सात्विक भोजन मिलता है। प्रवेश सीमित सीटों पर, कार्यालय की प्रक्रिया से होता है।',
  },
  religious: {
    title: 'धार्मिक गतिविधियां',
    text: 'नियमित पूजन, प्रवचन, पर्व और धार्मिक शिक्षण से दिगंबर जैन परंपरा सँभाली जाती है। श्रद्धालु इन आयोजनों में सम्मिलित हो सकते हैं।',
  },
  samaj: {
    title: 'समाजसेवा एवं सहयोग',
    text: 'अन्नदान, शैक्षिक सहायता और ज़रूरतमंद परिवारों तक पहुँच ट्रस्ट के समाजसेवा कार्य हैं। आर्थिक, वस्तु या समय — हर सहयोग सेवा बनता है।',
  },
}

const HELP = {
  general: {
    title: 'सहयोग के अवसर',
    text: 'आप आर्थिक दान, वस्तु सहायता, स्वयंसेवा या अपनी विशेष योग्यता से जीवदया, शिक्षा और समाजसेवा को संबल दे सकते हैं।',
  },
  money: {
    title: 'आर्थिक सहयोग',
    text: 'आर्थिक दान गौसेवा, छात्रावास और समाजसेवा के कार्यक्रमों में लगता है। ऑनलाइन दान पृष्ठ से योगदान कर सकते हैं।',
  },
  goods: {
    title: 'वस्तु सहयोग',
    text: 'अनाज, कपड़े, पुस्तकें, दवाइयाँ और सात्विक भोजन की सामग्री ट्रस्ट कार्यालय में स्वीकार की जाती है।',
  },
  volunteer: {
    title: 'स्वयंसेवक के रूप में',
    text: 'पूजन व्यवस्था, गोशाला, छात्रावास और सामुदायिक सेवा में समय देकर आप सीधे सेवा से जुड़ सकते हैं।',
  },
  other: {
    title: 'अन्य सहयोग',
    text: 'कौशल, प्रचार या कोई विशेष सहायता हो तो फोन या ईमेल लिखें। ट्रस्ट आपसे संपर्क करेगा।',
  },
}

const YOUTUBE_URL = 'https://www.youtube.com/@arihanttrust'
const INSTAGRAM_URL = 'https://www.instagram.com/shri_arihantdigambarjain_trust'

function SectionTitle({ children }) {
  return (
    <div className="mb-4 flex items-center justify-center gap-2 sm:mb-5 sm:gap-3">
      <span className="text-gold" aria-hidden="true">✦</span>
      <span className="h-px w-8 bg-gradient-to-r from-transparent to-gold sm:w-16" />
      <h2 className="text-center text-3xl text-maroon sm:text-4xl">{children}</h2>
      <span className="h-px w-8 bg-gradient-to-l from-transparent to-gold sm:w-16" />
      <span className="text-gold" aria-hidden="true">✦</span>
    </div>
  )
}

function Lotus({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.35" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 21c0-3 1.2-5 1.2-5S12 13 12 10" />
      <path d="M12 21c0-3-1.2-5-1.2-5S12 13 12 10" />
      <path d="M12 16c2.4-1.2 4.2-1 5.4.2-1.6 1.6-3.6 1.4-5.4-.2z" />
      <path d="M12 16c-2.4-1.2-4.2-1-5.4.2 1.6 1.6 3.6 1.4 5.4-.2z" />
      <path d="M12 13.2c2.2-1.6 4.6-1.2 6 .4-2 1.8-4.2 1.4-6-.4z" />
      <path d="M12 13.2c-2.2-1.6-4.6-1.2-6 .4 2 1.8 4.2 1.4 6-.4z" />
      <path d="M12 10.6c1.8-1.8 4.2-1.4 5.6.2-2.2 1.6-4 1.2-5.6-.2z" />
      <path d="M12 10.6c-1.8-1.8-4.2-1.4-5.6.2 2.2 1.6 4 1.2 5.6-.2z" />
    </svg>
  )
}

function Home() {
  const location = useLocation()
  const [service, setService] = useState(null)
  const [help, setHelp] = useState(null)
  const [aboutOpen, setAboutOpen] = useState(false)
  const [hostelOpen, setHostelOpen] = useState(false)
  const [admitOpen, setAdmitOpen] = useState(false)
  const [video, setVideo] = useState(null)
  const [photo, setPhoto] = useState(null)
  const [videos, setVideos] = useState([])
  const [photos, setPhotos] = useState([])
  const [instagramUrl, setInstagramUrl] = useState(INSTAGRAM_URL)
  const [banners, setBanners] = useState([])
  const [bannerIndex, setBannerIndex] = useState(0)

  useEffect(() => {
    if (!location.hash) return undefined
    const id = location.hash.slice(1)
    const timer = window.setTimeout(() => {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 60)
    return () => window.clearTimeout(timer)
  }, [location.hash])

  useEffect(() => {
    let mounted = true
    GetAction('get', {}, '/hero_banner/bannerList').then((res) => {
      if (!mounted || res?.status !== 'success' || !Array.isArray(res.response)) return
      const list = res.response
        .map((item) => ({
          id: item.banner_id,
          src: mediaUrl(item.image_path),
          alt: item.title || 'हीरो बैनर',
        }))
        .filter((item) => item.src)
      if (list.length) setBanners(list)
    })
    return () => {
      mounted = false
    }
  }, [])

  useEffect(() => {
    if (banners.length < 2) return undefined
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined
    const timer = window.setInterval(() => {
      setBannerIndex((index) => (index + 1) % banners.length)
    }, 5000)
    return () => window.clearInterval(timer)
  }, [banners.length])

  useEffect(() => {
    let mounted = true
    GetAction('get', {}, '/youtube/latestVideos').then((res) => {
      if (!mounted || res?.status !== 'success') return
      const list = res.response?.videos || []
      if (!list.length) return
      setVideos(
        list.slice(0, 3).map((item) => ({
          title: item.title,
          img: item.thumbnail,
          duration: item.published_label || '',
          href: item.url || (item.video_id ? `https://www.youtube.com/watch?v=${item.video_id}` : YOUTUBE_URL),
          embed: item.embed_url || (item.video_id ? `https://www.youtube-nocookie.com/embed/${item.video_id}` : ''),
        }))
      )
    })
    GetAction('get', {}, '/instagram/latestPosts').then((res) => {
      if (!mounted) return
      if (res?.response?.profile_url) setInstagramUrl(res.response.profile_url)
      if (res?.status !== 'success') return
      const list = res.response?.posts || []
      if (!list.length) return
      setPhotos(
        list.slice(0, 5).map((item) => ({
          title: item.title || 'Instagram',
          img: mediaUrl(item.image_path),
          href: item.url || INSTAGRAM_URL,
          embed: item.is_video ? item.embed_url : '',
          isVideo: Boolean(item.is_video),
        })).filter((item) => item.img)
      )
    })
    return () => {
      mounted = false
    }
  }, [])

  return (
    <>
      <Header />
      <div className="site-design bg-cream text-[#3d2918]">
        <main id="main">
          <section id="hero">
            <div className="hero-stage relative overflow-hidden">
              {banners.length ? (
                <div className="hero-slides" aria-hidden="true">
                  {banners.map((banner, index) => (
                    <img
                      key={banner.id || index}
                      src={banner.src}
                      alt=""
                      className={index === bannerIndex ? 'is-active' : ''}
                    />
                  ))}
                </div>
              ) : (
                <div className="hero-media" aria-hidden="true">
                  <img className="left" src={mockImg('hero-statue.jpg')} alt="" />
                  <img className="right" src={mockImg('hero-temple.jpg')} alt="" />
                </div>
              )}
              <div className="hero-glow" aria-hidden="true" />
              <div className="hero-shade" aria-hidden="true" />
              <div className="relative z-10 mx-auto max-w-3xl px-4 pb-10 pt-8 text-center sm:pb-12 sm:pt-10 lg:pt-12">
                <p className="text-base font-bold text-maroon sm:text-xl md:text-2xl">सेवा • संस्कार • जीवदया • समाज</p>
                <h1 className="mt-2 text-4xl text-[#24180f] sm:text-5xl md:text-[3.4rem]">“जीओ और जीने दो”</h1>
                <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-[#4e3928] sm:text-base">
                  के सिद्धांत के साथ समाज, शिक्षा, जीवदया और धार्मिक गतिविधियों के लिए समर्पित
                  <span className="mt-1 block font-semibold text-[#3d2918]">श्री अरिहंत दिगंबर जैन ट्रस्ट, चिंचवड, पुणे</span>
                </p>
                <div className="mt-4 flex flex-wrap items-center justify-center gap-3">
                  <Link to="/#works" className="inline-flex items-center gap-2 rounded-full bg-maroon px-5 py-2.5 text-sm font-semibold text-white shadow-md transition hover:-translate-y-0.5 hover:bg-[#660000]">हमारे कार्य जानें →</Link>
                  <Link to="/Donation" className="inline-flex items-center gap-2 rounded-full border-2 border-gold bg-white/80 px-5 py-2.5 text-sm font-semibold text-maroon shadow-sm transition hover:-translate-y-0.5 hover:bg-[#fff6df]">
                    <i className="fa-solid fa-heart text-gold" aria-hidden="true" />
                    दान करें
                  </Link>
                </div>
              </div>
            </div>
            {banners.length > 1 ? (
              <div className="flex justify-center gap-2 pt-3" role="tablist" aria-label="हीरो बैनर">
                {banners.map((banner, index) => (
                  <button
                    key={banner.id || index}
                    type="button"
                    role="tab"
                    aria-selected={index === bannerIndex}
                    aria-label={`बैनर ${index + 1}`}
                    className={`h-2.5 w-2.5 rounded-full ${index === bannerIndex ? 'bg-maroon' : 'bg-[#e4c98a]'}`}
                    onClick={() => setBannerIndex(index)}
                  />
                ))}
              </div>
            ) : null}
          </section>

          <section id="about" className="bg-cream px-4 py-6 sm:py-8">
            <div className="mx-auto max-w-7xl">
              <SectionTitle>हमारे बारे में</SectionTitle>
              <div className="grid items-center gap-6 lg:grid-cols-[1.15fr_.95fr]">
                <div>
                  <p className="text-[15px] leading-7 text-[#4a3728] sm:text-base">
                    श्री अरिहंत दिगंबर जैन ट्रस्ट, चिंचवड, पुणे धार्मिक, सामाजिक, शैक्षणिक एवं जीवदया से जुड़े विविध सेवा कार्यों के माध्यम से समाज के लिए निरंतर कार्यरत है। भगवान महावीर के “जीओ और जीने दो” के संदेश को केंद्र में रखते हुए हम जीवदया, शिक्षा, छात्रावास, धार्मिक आयोजनों एवं समाजोपयोगी गतिविधियों के माध्यम से सेवा का प्रयास करते हैं।
                  </p>
                  <button type="button" className="mt-6 inline-flex items-center gap-2 rounded-full bg-maroon px-5 py-2.5 text-sm font-semibold text-white shadow transition hover:-translate-y-0.5 hover:bg-[#660000]" onClick={() => setAboutOpen(true)}>और जानें →</button>
                </div>
                <div className="grid grid-cols-2 gap-x-3 gap-y-6 sm:grid-cols-4">
                  {[
                    ['fa-leaf', 'करुणा', 'हमारी प्रेरणा'],
                    ['fa-book-open', 'संस्कार', 'हमारी पहचान'],
                    ['fa-hands-praying', 'सेवा', 'हमारा उद्देश्य'],
                  ].map(([icon, title, sub]) => (
                    <div key={title} className="text-center">
                      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-gold/40 bg-[#F8EFCF] text-2xl text-gold shadow-sm sm:h-24 sm:w-24">
                        <i className={`fa-solid ${icon}`} />
                      </div>
                      <p className="mt-2 font-semibold text-maroon">{title}</p>
                      <p className="text-xs text-[#6d5844]">{sub}</p>
                    </div>
                  ))}
                  <div className="text-center">
                    <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-gold/40 bg-[#F8EFCF] text-2xl text-gold shadow-sm sm:h-24 sm:w-24">
                      <Lotus className="h-8 w-8" />
                    </div>
                    <p className="mt-2 font-semibold text-maroon">समाज</p>
                    <p className="text-xs text-[#6d5844]">हमारा परिवार</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="works" className="bg-[#FFF9EE] px-4 py-6 sm:py-8">
            <div className="mx-auto max-w-7xl">
              <SectionTitle>हमारे प्रमुख कार्य</SectionTitle>
              <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                {[
                  ['gauseva', 'svc-cow.jpg', 'श्वेत गौ माताएँ', 'fa-cow', 'जीवदया एवं गौसेवा', 'गौ-वंश के संरक्षण, पौष्टिक आहार की आपूर्ति एवं पशु सेवा के विभिन्न कार्यक्रम।'],
                  ['education', 'svc-study.jpg', 'अध्ययनरत विद्यार्थी', 'fa-graduation-cap', 'छात्रावास एवं शिक्षा', 'विद्यार्थियों के लिए सुरक्षित, संस्कारपूर्ण वातावरण और शैक्षणिक सुविधाएँ।'],
                  ['religious', 'svc-temple.jpg', 'मंदिर में दीप', 'fa-place-of-worship', 'धार्मिक गतिविधियां', 'पूजन, धार्मिक आयोजन एवं आध्यात्मिक गतिविधियों के माध्यम से धर्म के प्रचार-प्रसार के कार्य।'],
                  ['samaj', 'svc-food.jpg', 'भोजन वितरण', 'fa-handshake-angle', 'समाजसेवा एवं सहयोग', 'समाज के विभिन्न वर्गों के लिए सहायता, सेवा एवं सहयोग के कार्यक्रम।'],
                ].map(([id, file, alt, icon, title, text]) => (
                  <article id={id} key={id} className="group flex h-full flex-col rounded-2xl border border-[#f0e2c4] bg-white shadow-card transition duration-300 hover:-translate-y-1">
                    <div className="relative">
                      <div className="h-40 overflow-hidden rounded-t-2xl bg-[#f3e0b5] sm:h-44">
                        <img src={mockImg(file)} alt={alt} className="h-full w-full object-cover transition duration-500 group-hover:scale-110" />
                      </div>
                      <span className="absolute -bottom-5 left-4 z-10 flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 bg-white text-lg text-gold shadow">
                        <i className={`fa-solid ${icon}`} />
                      </span>
                    </div>
                    <div className="flex flex-1 flex-col px-4 pb-5 pt-8">
                      <h3 className="text-lg text-maroon">{title}</h3>
                      <p className="mt-2 flex-1 text-sm leading-6 text-[#5c4938]">{text}</p>
                      <button type="button" className="mt-3 inline-flex items-center gap-1 self-start text-sm font-semibold text-maroon transition hover:gap-2" onClick={() => setService(id)}>और जानें →</button>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>

          <section className="bg-cream px-4 py-6 sm:py-8" aria-label="प्रभाव और सहभागिता">
            <div className="mx-auto grid max-w-7xl gap-6 lg:grid-cols-2">
              <article className="grid overflow-hidden rounded-3xl border border-[#f0e2c4] bg-white shadow-card md:grid-cols-[190px_1fr]">
                <div className="relative h-52 bg-[#f3e0b5] md:h-auto">
                  <img src={mockImg('impact.jpg')} alt="हाथों में नया पौधा" className="absolute inset-0 h-full w-full object-cover object-center" />
                </div>
                <div className="p-5 sm:p-6">
                  <h2 className="text-2xl text-maroon sm:text-3xl">हमारा प्रभाव</h2>
                  <p className="mt-2 text-sm leading-7 text-[#5c4938]">समाज के सहयोग से अनेक क्षेत्रों में सेवा कार्य निरंतर जारी है। आपका सहयोग इस प्रयास को और मजबूत बनाता है।</p>
                  <div className="mt-4 grid grid-cols-1 gap-2 min-[420px]:grid-cols-2">
                    <div className="flex items-center gap-2 rounded-xl border border-[#f0e2c4] bg-white px-3 py-2 shadow-sm"><i className="fa-solid fa-cow text-maroon" /><span><span className="block text-sm font-semibold text-maroon">गौसेवा</span><span className="block text-[10px] text-[#8a735c]">सेवा अभियान</span></span></div>
                    <div className="flex items-center gap-2 rounded-xl border border-[#f0e2c4] bg-white px-3 py-2 shadow-sm"><i className="fa-solid fa-graduation-cap text-maroon" /><span><span className="block text-sm font-semibold text-maroon">छात्रावास</span><span className="block text-[10px] text-[#8a735c]">विद्यार्थियों के लिए</span></span></div>
                    <div className="flex items-center gap-2 rounded-xl border border-[#f0e2c4] bg-white px-3 py-2 shadow-sm"><i className="fa-solid fa-user-group text-maroon" /><span><span className="block text-sm font-semibold text-maroon">समाजसेवा</span><span className="block text-[10px] text-[#8a735c]">समाज के लिए</span></span></div>
                    <div className="flex items-center gap-2 rounded-xl border border-[#f0e2c4] bg-white px-3 py-2 shadow-sm"><Lotus className="h-4 w-4 text-maroon" /><span><span className="block text-sm font-semibold text-maroon">धार्मिक आयोजन</span><span className="block text-[10px] text-[#8a735c]">आध्यात्मिक उन्नति के लिए</span></span></div>
                  </div>
                </div>
              </article>
              <article className="grid overflow-hidden rounded-3xl border border-[#f0e2c4] bg-[#FFF9F2] shadow-card md:grid-cols-[1fr_180px]">
                <div className="order-2 p-5 sm:p-6 md:order-1">
                  <h2 className="text-2xl text-maroon sm:text-[1.7rem]">हमसे जुड़ें – सेवा में सहभागी बनें</h2>
                  <p className="mt-2 text-sm leading-7 text-[#5c4938]">आप भी जीवदया, शिक्षा, धार्मिक एवं समाजसेवा के कार्यक्रमों में योगदान देकर इस नेक काम का हिस्सा बन सकते हैं।</p>
                  <button type="button" className="mt-4 inline-flex items-center gap-2 rounded-full bg-maroon px-4 py-2 text-sm font-semibold text-white" onClick={() => setHelp('general')}>सहयोग के अवसर →</button>
                  <div className="mt-4 grid grid-cols-2 gap-2">
                    <button type="button" className="inline-flex items-center justify-center gap-1.5 rounded-full border border-[#f0d0d0] bg-white px-2 py-2 text-xs font-medium text-maroon sm:text-sm" onClick={() => setHelp('money')}><i className="fa-solid fa-heart" /> आर्थिक सहयोग</button>
                    <button type="button" className="inline-flex items-center justify-center gap-1.5 rounded-full border border-[#f0d0d0] bg-white px-2 py-2 text-xs font-medium text-maroon sm:text-sm" onClick={() => setHelp('goods')}><i className="fa-solid fa-gift" /> वस्तु सहयोग</button>
                    <button type="button" className="inline-flex items-center justify-center gap-1.5 rounded-full border border-[#f0d0d0] bg-white px-2 py-2 text-center text-xs font-medium leading-tight text-maroon sm:text-sm" onClick={() => setHelp('volunteer')}><i className="fa-solid fa-user-group" /> स्वयंसेवक के रूप में</button>
                    <button type="button" className="inline-flex items-center justify-center gap-1.5 rounded-full border border-[#f0d0d0] bg-white px-2 py-2 text-xs font-medium text-maroon sm:text-sm" onClick={() => setHelp('other')}><i className="fa-solid fa-handshake" /> अन्य सहयोग</button>
                  </div>
                </div>
                <div className="relative order-1 h-48 bg-[#f3e0b5] md:order-2 md:h-auto">
                  <img src={mockImg('hands.jpg')} alt="प्रार्थना में जुड़े हाथ" className="absolute inset-0 h-full w-full object-cover object-center" />
                </div>
              </article>
            </div>
          </section>

          <section id="hostel" className="bg-[#FFF9EE] px-4 py-6 sm:py-8">
            <div className="mx-auto max-w-7xl">
              <SectionTitle>हमारा छात्रावास</SectionTitle>
              <article className="grid overflow-hidden rounded-3xl border border-[#f0e2c4] bg-white shadow-card lg:grid-cols-[1.05fr_1.25fr_.85fr]">
                <div className="relative min-h-[230px] bg-[#f3e0b5]">
                  <img src={mockImg('hostel.jpg')} alt="श्री अरिहंत छात्रावास" className="absolute inset-0 h-full w-full object-cover object-center" />
                </div>
                <div className="p-5 sm:p-7">
                  <h3 className="text-xl text-maroon sm:text-2xl">शिक्षा के साथ संस्कार और सुरक्षित वातावरण</h3>
                  <p className="mt-2 text-sm leading-7 text-[#5c4938]">विद्यार्थियों के लिए सुरक्षित, अनुशासित और संस्कारपूर्ण आवास सुविधा, ताकि वे शिक्षा के साथ-साथ अपने मूल्य और संस्कृति से भी जुड़े रहें।</p>
                  <ul className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
                    {[
                      ['fa-house-chimney', 'सुरक्षित आवास'],
                      ['fa-book-open', 'शैक्षणिक वातावरण'],
                      ['fa-spa', 'संस्कार एवं मूल्य'],
                      ['fa-utensils', 'सात्विक भोजन'],
                    ].map(([icon, label]) => (
                      <li key={label} className="text-center">
                        <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-[#F8EFCF] text-maroon"><i className={`fa-solid ${icon}`} /></span>
                        <span className="mt-1 block text-[11px] leading-tight text-[#4a3728] sm:text-xs">{label}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-5 flex flex-wrap gap-3">
                    <button type="button" className="inline-flex items-center rounded-full bg-maroon px-4 py-2 text-sm font-semibold text-white" onClick={() => setHostelOpen(true)}>छात्रावास के बारे में →</button>
                    <button type="button" className="inline-flex items-center rounded-full border-2 border-gold bg-white px-4 py-2 text-sm font-semibold text-maroon" onClick={() => setAdmitOpen(true)}>प्रवेश जानकारी →</button>
                  </div>
                </div>
                <div className="relative min-h-[220px] bg-[#f3e0b5]">
                  <img src={mockImg('hostel-students.jpg')} alt="अध्ययन करती छात्राएँ" className="absolute inset-0 h-full w-full object-cover object-right" />
                </div>
              </article>
            </div>
          </section>

          <section className="bg-cream px-4 py-6 sm:py-8">
            <div className="social-pair mx-auto grid max-w-7xl gap-6 lg:grid-cols-2">
              <div id="yatri" className="social-col min-w-0">
                <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex min-w-0 items-center gap-2">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-red-600 text-white"><i className="fa-brands fa-youtube" /></span>
                    <h2 className="text-2xl text-maroon sm:text-3xl">हमारे YouTube चैनल से</h2>
                  </div>
                  <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className="shrink-0 whitespace-nowrap text-sm font-semibold text-maroon hover:text-gold">सभी वीडियो देखें →</a>
                </div>
                {videos.length ? (
                  <div className="grid gap-3 sm:grid-cols-3">
                    {videos.map((item) => (
                      <button type="button" key={item.href || item.title} className="group text-left" onClick={() => setVideo(item)}>
                        <span className="relative block overflow-hidden rounded-xl bg-[#f3e0b5]">
                          <img src={item.img} alt="" className="aspect-[2.35/1] w-full object-cover object-center transition duration-500 group-hover:scale-105" />
                          <span className="pointer-events-none absolute inset-0 flex items-center justify-center">
                            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-black/55 text-white"><i className="fa-solid fa-play ml-0.5 text-sm" /></span>
                          </span>
                        </span>
                        <span className="mt-2 block min-h-[2.6rem] text-sm font-semibold leading-snug text-[#3d2918]">{item.title}</span>
                        {item.duration ? <span className="mt-1 block text-xs text-[#6b5344]">{item.duration}</span> : null}
                      </button>
                    ))}
                  </div>
                ) : (
                  <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-maroon hover:text-gold">चैनल पर नवीनतम वीडियो देखें →</a>
                )}
              </div>
              <div id="gallery" className="social-col min-w-0">
                <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex min-w-0 items-center gap-2">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-amber-400 via-pink-500 to-purple-600 text-white"><i className="fa-brands fa-instagram" /></span>
                    <h2 className="text-2xl text-maroon sm:text-3xl">Instagram पर हमारे साथ जुड़ें</h2>
                  </div>
                  <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="shrink-0 whitespace-nowrap text-sm font-semibold text-maroon hover:text-gold">हमें Follow करें →</a>
                </div>
                {photos.length ? (
                  <div className="grid grid-cols-3 gap-3 sm:grid-cols-5">
                    {photos.map((item) => (
                      <button type="button" key={item.href || item.img} className="relative overflow-hidden rounded-xl bg-[#f3e0b5]" aria-label={`${item.title} देखें`} onClick={() => setPhoto(item)}>
                        <img src={item.img} alt={item.title} className="aspect-square w-full object-cover transition duration-500 hover:scale-105" />
                        {item.isVideo ? (
                          <span className="pointer-events-none absolute inset-0 flex items-center justify-center">
                            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-black/55 text-white"><i className="fa-solid fa-play ml-0.5 text-xs" /></span>
                          </span>
                        ) : null}
                      </button>
                    ))}
                  </div>
                ) : (
                  <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-maroon hover:text-gold">Instagram पर नवीनतम पोस्ट देखें →</a>
                )}
              </div>
            </div>
          </section>
        </main>

        {aboutOpen ? (
          <Modal onClose={() => setAboutOpen(false)}>
            <div className="max-h-[80vh] w-[min(92vw,36rem)] overflow-y-auto rounded-2xl bg-cream p-6 text-[#3d2918] shadow-2xl">
              <ModalHead title="ट्रस्ट का परिचय" onClose={() => setAboutOpen(false)} />
              <p className="mt-3 text-sm leading-7 text-[#5c4938]">श्री अरिहंत दिगंबर जैन ट्रस्ट, चिंचवड, पुणे भगवान महावीर के “जीओ और जीने दो” संदेश पर चलता है। करुणा हमारी प्रेरणा है, संस्कार हमारी पहचान, सेवा हमारा उद्देश्य और समाज हमारा परिवार।</p>
              <p className="mt-3 text-sm leading-7 text-[#5c4938]">ट्रस्ट गौसेवा, विद्यार्थियों के छात्रावास, पूजन व धार्मिक आयोजन, तथा ज़रूरतमंदों तक सहायता पहुँचाने के कार्य करता है।</p>
              <Link to="/#works" className="mt-4 inline-flex rounded-full bg-maroon px-4 py-2 text-sm font-semibold text-white" onClick={() => setAboutOpen(false)}>हमारे कार्य देखें →</Link>
            </div>
          </Modal>
        ) : null}

        {service ? (
          <Modal onClose={() => setService(null)}>
            <div className="w-[min(92vw,34rem)] rounded-2xl bg-cream p-6 text-[#3d2918] shadow-2xl">
              <ModalHead title={SERVICES[service].title} onClose={() => setService(null)} />
              <p className="mt-3 text-sm leading-7 text-[#5c4938]">{SERVICES[service].text}</p>
              <Link to="/Donation" className="mt-4 inline-flex rounded-full bg-gold px-4 py-2 text-sm font-semibold text-maroon" onClick={() => setService(null)}>इस कार्य में सहयोग करें →</Link>
            </div>
          </Modal>
        ) : null}

        {help ? (
          <Modal onClose={() => setHelp(null)}>
            <div className="w-[min(92vw,34rem)] rounded-2xl bg-cream p-6 text-[#3d2918] shadow-2xl">
              <ModalHead title={HELP[help].title} onClose={() => setHelp(null)} />
              <p className="mt-3 text-sm leading-7 text-[#5c4938]">{HELP[help].text}</p>
              <p className="mt-3 text-sm leading-7 text-[#5c4938]">
                फोन: <a className="font-semibold text-maroon underline" href="tel:9876543210">9876543210</a>
                <br />
                ईमेल: <a className="font-semibold text-maroon underline" href="mailto:office@arihant.org.in">office@arihant.org.in</a>
              </p>
              {help === 'money' ? (
                <Link to="/Donation" className="mt-4 inline-flex rounded-full bg-maroon px-4 py-2 text-sm font-semibold text-white" onClick={() => setHelp(null)}>ऑनलाइन दान करें →</Link>
              ) : null}
            </div>
          </Modal>
        ) : null}

        {hostelOpen ? (
          <Modal onClose={() => setHostelOpen(false)}>
            <div className="w-[min(92vw,36rem)] rounded-2xl bg-cream p-6 text-[#3d2918] shadow-2xl">
              <ModalHead title="श्री अरिहंत छात्रावास" onClose={() => setHostelOpen(false)} />
              <p className="mt-3 text-sm leading-7 text-[#5c4938]">छात्रावास विद्यार्थियों को सुरक्षित आवास, शांत अध्ययन, संस्कार और सात्विक भोजन देता है।</p>
              <ul className="mt-3 list-disc space-y-1 pl-5 text-sm text-[#5c4938]">
                <li>सुरक्षित आवास और देखरेख</li>
                <li>पढ़ाई के लिए शांत वातावरण</li>
                <li>संस्कार एवं मूल्य की शिक्षा</li>
                <li>सात्विक भोजन</li>
              </ul>
            </div>
          </Modal>
        ) : null}

        {admitOpen ? (
          <Modal onClose={() => setAdmitOpen(false)}>
            <div className="w-[min(92vw,36rem)] rounded-2xl bg-cream p-6 text-[#3d2918] shadow-2xl">
              <ModalHead title="प्रवेश जानकारी" onClose={() => setAdmitOpen(false)} />
              <ol className="mt-3 list-decimal space-y-2 pl-5 text-sm leading-7 text-[#5c4938]">
                <li>विद्यालय या अभिभावक का अनुरोध पत्र कार्यालय में दें।</li>
                <li>पहचान पत्र, पिछली कक्षा का परिणाम और निवास का पता साथ रखें।</li>
                <li>सीट उपलब्ध होने पर ट्रस्ट कार्यालय संपर्क करेगा।</li>
              </ol>
              <p className="mt-3 text-sm text-[#5c4938]">पूछताछ: <a className="font-semibold text-maroon underline" href="tel:9876543210">9876543210</a></p>
            </div>
          </Modal>
        ) : null}

        {video ? (
          <Modal onClose={() => setVideo(null)}>
            <div className="w-[min(92vw,36rem)] rounded-2xl bg-ink p-4 text-white shadow-2xl sm:p-5">
              <div className="flex items-start justify-between gap-3">
                <h2 className="text-xl text-[#FFE7A3]">{video.title}</h2>
                <button type="button" className="flex h-8 w-8 items-center justify-center rounded-full hover:bg-white/10" aria-label="बंद करें" onClick={() => setVideo(null)}><i className="fa-solid fa-xmark" /></button>
              </div>
              {video.embed ? (
                <iframe
                  src={video.embed}
                  title={video.title}
                  className="mt-3 aspect-video w-full rounded-xl border-0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              ) : (
                <img src={video.img} alt="" className="mt-3 aspect-video w-full rounded-xl object-cover" />
              )}
              {video.duration ? <p className="mt-2 text-sm text-white/70">{video.duration}</p> : null}
              <a href={video.href || YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-2 rounded-full bg-red-600 px-4 py-2 text-sm font-semibold">
                YouTube पर खोलें <i className="fa-brands fa-youtube" />
              </a>
            </div>
          </Modal>
        ) : null}

        {photo ? (
          <Modal onClose={() => setPhoto(null)}>
            <div className="w-[min(92vw,36rem)] rounded-2xl bg-cream p-4 text-[#3d2918] shadow-2xl sm:p-5">
              <ModalHead title={photo.title} onClose={() => setPhoto(null)} />
              {photo.embed ? (
                <iframe src={photo.embed} title={photo.title} className="mt-3 aspect-[9/16] max-h-[70vh] w-full rounded-xl border-0" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
              ) : (
                <img src={photo.img} alt={photo.title} className="mt-3 max-h-[60vh] w-full rounded-xl object-cover" />
              )}
              <a href={photo.href || instagramUrl} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-maroon hover:text-gold">Instagram पर खोलें →</a>
            </div>
          </Modal>
        ) : null}
      </div>
      <Footer />
    </>
  )
}

export default Home
